import { lazy } from 'react';
import { Route } from 'react-router-dom';

const DefaultRoute = lazy(() => import('./default-route'));

export default {
  routes: [<Route key="/" exact path="/" component={DefaultRoute} />],
};
